import { open, close } from '../../../services/modal';

// eslint-disable-next-line import/prefer-default-export
export function historicalRemovedModal() {
  $(document).on('click', '.prevent-removed-resources-submit', (e) => {
    if ($('#from-date').val() !== '' && $('#to-date').val() !== '') {
      open($('#modal-removed-resources-form').html(), $(e.target).parents('body')[0]);
    }
  });

  $(document).on('click', '.submit-removed-resources-form', (e) => {
    e.preventDefault();
    const $this = $(e.target);

    $this.addClass('disabled').text($this.data('disable-with'));

    $('.prevent-removed-resources-submit').addClass('is-hidden');
    $('#submit-removed-resources').removeClass('is-hidden').click();
    close();
  });
}

$(document).on('change', '#from-date, #to-date', () => {
  if ($('#from-date').val() !== '' && $('#to-date').val() !== '') {
    $('.prevent-removed-resources-submit').removeClass('is-disabled');
  } else {
    $('.prevent-removed-resources-submit').addClass('is-disabled');
  }
});
